// @/locales/lang/en-US/menu.ts
export default {
  'menu.(public).dashboard': 'Dashboard',
  'menu.(public).(public).trade': 'Trade',
  'menu.(public).account.home': 'Account',
  'menu.(public).activities.home': 'Activities',
  'menu.(public).(public).analysis': 'Analysis',
  'menu.(public).deposit': 'Deposit',
  'menu.(public).deposit.pay': 'Deposit Amount',
  'menu.(public).deposit.home': 'Deposit',
  'menu.(public).download': 'Download',
  'menu.(public).files': 'Files',
  'menu.(public).follow': 'Copy Trading',
  'menu.(public).follow.my': 'My Copy Trading',
  'menu.(public).follow.request-signal-source': 'My Signal Source',
  'menu.(public).fund-details': 'Fund Details',
  'menu.(public).notifications.home': 'Notifications',
  'menu.(public).pamm': 'PAMM',
  'menu.(public).pamm.home': 'PAMM Supermarket',
  'menu.(public).pamm.my': 'My PAMM',
  'menu.(public).pamm.customer-profit-loss': 'Customer Profit & Loss',
  'menu.(public).pamm.order-detail': 'Order Details',
  'menu.(public).points': 'Points',
  'menu.(public).settings': 'Settings',
  'menu.(public).settings.home': 'Settings',
  'menu.(public).settings.security-center': 'Security Center',
  'menu.(public).settings.passkey': 'Passkey',
  'menu.(public).settings.authenticator': 'Authenticator',
  'menu.(public).settings.bind-google': 'Bind Google',
  'menu.(public).settings.device-manage': 'Device Management',
  'menu.(public).settings.security-center.device-manage': 'Device Management',
  'menu.(public).settings.logs': 'Log Management',
  'menu.(public).settings.security-center.logs': 'Log Management',
  'menu.(public).share.home': 'Share',
  'menu.(public).transaction-reports': 'Transaction Reports',
  'menu.(public).transaction-reports.home': 'Transaction Reports',
  'menu.(public).transfer': 'Transfer',
  'menu.(public).user.login': 'Login',
  'menu.(public).withdraw.home': 'Withdrawal',
  'menu.(public).work-orders.home': 'Work Orders',
  'menu.(public).work-orders.create': 'Create Work Order',
  'menu.(public).exception.not-permission': '403',
  'menu.(public).exception.not-find': '404',
  'menu.(public).exception.server-error': '500',
  'menu.(public).exception.trigger': 'Trigger Error',
  'menu.(public).course.home': 'Course',
  'menu.(public).copy-trading': 'Copy Trading',

  'menu.public': 'Home',
  'menu.trading': 'Trading',
  'menu.CopyTrading': 'Copy Trading',
  'menu.GtcCopy': 'GTC Copy Trading',
  'menu.GtcCopyDiscoverSignals': 'Discover Signals',
  'menu.GtcCopyDiscoverSignalsDetails': 'Signal Details',
  'menu.GtcCopyAllSignal': 'All Signals',
  'menu.GtcCopyAllSignalDetails': 'Signal Details',
  'menu.GtcCopyAssets': 'My Copy Trading',
  'menu.GtcCopyAssetsDetails': 'Copy Trading Details',
  'menu.GtcCopyMyPublish': 'My Published',
  'menu.GtcCopyMyPublishCreateSignals': 'Create Copy Trading Signal',
  'menu.GtcCopyMyPublishDetails': 'Signal Details',
  'menu.GtcCopyMyPublisReport': 'Signal Report',
  'menu.GtcCopyMyShare': 'My Share/Referral',
  'menu.GtcCopyShareDetails': 'Details',

  'menu.InPlatformCopy': 'In-Platform Copy Trading',
  'menu.InPlatformCopySignalDetails': 'Signal Source Details',
  'menu.InPlatformCopyStartCopy': 'Copy Trading',
  'menu.InPlatformCopyAssets': 'My Copy Trading',
  'menu.InPlatformCopyMyPublish': 'My Published',
  'menu.GtcCopyMyPublisDetails': 'Signal Details',
  'menu.InPlatformCopyCreateSignals': 'Publish Signal Source',
  'menu.InPlatformCopyMyPublishDetails': 'Details',

  'menu.OutPlatformCopy': 'Cross-Platform Copy Trading',
  'menu.OutPlatformCopySignalDetails': 'Signal Source Details',
  'menu.OutPlatformCopyStartCopy': 'Copy Trading',
  'menu.OutPlatformCopyAssets': 'My Copy Trading',
  'menu.OutPlatformCopyMyPublish': 'My Published',
  'menu.OutPlatformCopyCreateSignals': 'Publish Signal Source',
  'menu.OutPlatformCopyMyPublishDetails': 'Details',

  'menu.(public).contract-management': 'Contract Management',
  'menu.(public).contract-management.home': 'Contract Management',
  'menu.(public).contract-management.view': 'View',
  'menu.(public).contract-management.ib': 'IB Agreement Signing',
  'menu.introducing-broker.commission-details': 'Commission Details',
  'menu.introducing-broker.fund-details': 'Fund Details',
  'menu.introducing-broker.transaction-reports': 'Transaction Reports',
  'menu.introducing-broker.promotion-materials': 'Promotion Materials',
  'menu.PammSignalDetails': 'PAMM Details',
  'menu.PammSignal': 'PAMM',
}
